import { useState } from 'react';

import { format, isValid } from 'date-fns';

import { DateValue } from '@cfa/react-core';

import { isValidYear } from '@/utils/date';

export interface DueDateFormState {
  canSave: boolean;
  checkboxClicked: boolean;
  disableDatePicker: boolean;
  getSaveValue: () => string | null;
  onCheckboxClick: () => void;
  onDateChange: (date: DateValue | null) => void;
}

export const useDueDateForm = (): DueDateFormState => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [checkboxClicked, setCheckboxClicked] = useState(false);

  const onDateChange = (date: DateValue | null) => {
    if (!date) {
      setSelectedDate(null);
      return;
    }

    // Only set date if year is valid (ensure 4 digit year)
    if (isValidYear(date.year)) {
      const formattedDate = format(
        date.toDate(Intl.DateTimeFormat().resolvedOptions().timeZone),
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      );
      if (isValid(new Date(formattedDate))) {
        setSelectedDate(formattedDate);
      }
    } else {
      setSelectedDate(null);
    }
  };

  const onCheckboxClick = () => {
    setCheckboxClicked(prev => !prev);
  };

  const getSaveValue = () => (checkboxClicked ? null : selectedDate);

  return {
    canSave: !!selectedDate || checkboxClicked,
    checkboxClicked,
    disableDatePicker: checkboxClicked,
    getSaveValue,
    onCheckboxClick,
    onDateChange,
  };
};
